import { render } from "./AgeGate.vue?vue&type=template&id=5f250806&scoped=true"
import script from "./AgeGate.vue?vue&type=script&lang=js"
export * from "./AgeGate.vue?vue&type=script&lang=js"

import "./AgeGate.vue?vue&type=style&index=0&id=5f250806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f250806"]])

export default __exports__